import useAuth from 'hooks/useAuth';
import normalizeEmail from 'utils/normalizeEmail';

export default function useHandleAccess() {
  const { db } = useAuth();
  const handleAccess = async (email: string, access: boolean) => {
    const normalized = normalizeEmail(email);
    if (!normalized) throw new Error('No email found for this contact');

    const ref = db.collection('access').doc(normalized);
    if (access) {
      await ref.set({ enabled: true }, { merge: true });
    } else {
      await ref.delete();
    }
  };

  return handleAccess;
}
